import {IssuePersonalData} from "../domain/entities/issue-personal-data.entity";
import {CommandName} from "./command-name.enum";
import {AbstractCommand} from "./abstract.command";

/** See CreateIssuePersonalDataCommand's doc comment on mainEntityClass/mainEntityUid. */
export class UpdateIssuePersonalDataCommand extends AbstractCommand<IssuePersonalData> {

    name = CommandName.UPDATE_ISSUE_PERSONAL_DATA;

    tags = ['entity', 'update', 'issue-personal-data'];

}
